import D2C_ServiceData from './Data'

class D2C_ServicePercona extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 25
  static typeName = 'percona'
  static typeTitle = 'Percona'
  static color = '#ff9933'
  static methods = {
    ...D2C_ServiceData.methods,
    backupDatabase: true,
    resetPassword: true,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'my.cnf', text: require('raw-loader!@/assets/configs/percona-my.cnf').default, custom: false},
      ],
    },
    configuration: {
      default: 'StandAlone',
      enum: [
        {value: 'StandAlone', text: 'StandAlone'},
        {value: 'MasterSlave', text: 'MasterSlave'},
      ],
      label: 'Configuration',
      path: 'configuration',
      required: false,
      validate() {
        return null
      },
      creating: {},
      migrating: {
        readonly: true,
        required: true,
      },
      importing: {},
    },
    database: {
      default: '',
      label: 'Create database',
      path: 'database',
      validate(value) {
        if (value && value.length > 63) {
          return 'Maximum length is 63 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        StandAlone: ['master'],
        MasterSlave: ['master', 'slave'],
      },
      validate(value, entity) {
        if (entity.configuration === 'MasterSlave') {
          const masters = entity.hosts.filter(host => host.role === 'master')
          const slaves = entity.hosts.filter(host => host.role === 'slave')
          if (!masters.length && !entity.created) {
            return 'Master host is not selected'
          }
          if (!slaves.length) {
            return 'Must be selected at least one slave'
          }
          if (value.length > 16) {
            return 'Available only 16 selected hosts'
          }
        }
        return (value && value.length > 0) ? null : 'Must be selected at least one host'
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'percona',
    },
    password: {
      default: '',
      label: 'Superuser password',
      path: 'password',
      required: false,
      superuser: 'root',
      width: 9,
      validate(value, entity) {
        if (entity.remoteAccess && !entity.hasPassword && !value) {
          return 'Database with remote access must have a password!'
        }
        if ((value || this.required) && value.length < 6) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
      resetingPassword: {
        autoselect: true,
        label: 'New superuser password',
        required: true,
      },
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 3306},
      ],
    },
    username: {
      default: '',
      label: 'Username',
      path: 'username',
      required: false,
      width: 7,
      validate(value, entity) {
        if (value && value.length > 32) {
          return 'Maximum length is 32 symbols'
        }
        if (!value && entity.userPassword) {
          return 'Username is not set'
        }
        if (value && value.toLowerCase() === 'root') {
          return 'Unavailable value'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    userPassword: {
      default: '',
      label: 'User password',
      path: 'userPassword',
      required: false,
      width: 9,
      validate(value, entity) {
        if (!entity.username && !value) {
          return null
        }
        if (entity.username && !value) {
          return 'Password is not set'
        }
        if (value && value.length < 6) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '5.7',
      enum: ['5.6', '5.7', '8.0'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/var/lib/mysql', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/etc/mysql/conf.d', sync: false},
      ],
    },
  }
}

export default D2C_ServicePercona
